import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { Button, Col, FormGroup, Label, ModalBody, ModalFooter, ModalHeader, Row, Input } from "reactstrap";
import ReactDatetime from 'react-datetime';
import Swal from "sweetalert2";
import rest from "lib/rest";
import rotas from "services/rotas";

const Analisar = ({ onClose, filial_id, sessao_id }) => {

  const [filtros, setFiltros] = useState({ dataI: '', dataF: '', dias: '' });

  const onChangeFiltro = (e) => {    

    let flt = { ...filtros }

    flt[e.target.name] = e.target.value;

    setFiltros(flt);
  }

  const onChangeDate = (e, name) => {
    let flt = { ...filtros };

    if (e.length !== undefined) {
      if ((e.length === 2) || (e.length === 5)) {
        flt[name] = e + '/';
      } else {
        flt[name] = e;
      }
    } else {
      flt[name] = e.format('DD/MM/YYYY');
    }
    setFiltros(flt);
  }

  const analisar = () => {
    if ((filtros.dataI === '') || (filtros.dataF === '') || (filtros.dias === '') || (filtros.dias === '0')) {
      Swal.fire('Atenção', 'Por Favor Preencha Todos os Campos', 'warning');
      return;
    }


    Swal.fire({
      title: "Confirma a análise do pedido?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidos;

        let flt = filtros;
        flt.filial_id = filial_id;
        flt.sessao_id = sessao_id;

        const parametros = {
          filtros: flt
        }

        return rest.post(url, parametros);
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success === 'S') {
          onClose();
        } else {
          Swal.fire('Atenção', 'Erro ao Analisar o Pedido!', 'warning');
        }
      }
    });
  }

  return (
    <>
      <ModalHeader>Análise de Produtos</ModalHeader>

      <ModalBody>
        <Row>
          <Col>
            <FormGroup>
              <Label>Dias a Suprir</Label>
              <NumberFormat
                name="dias"
                type="number"
                className={"form-control"}
                //value={form.cli_cpf}
                onChange={onChangeFiltro}
              />
            </FormGroup>
          </Col>

          <Col className="d-flex align-items-end">
            <FormGroup check inline className="pb-2">
              <Label check>
                <Input
                  type="checkbox"
                  id="gerar_comissao_fp"
                //onClick={onChange('gerar_comissao_fp')}
                //defaultChecked={form.gerar_comissao_fp === 'S' ? true : false}
                />
                <span className="form-check-sign" />{'Apenas Repor de Estoque (Nâo Analisar)'}
              </Label>
            </FormGroup>{" "}
          </Col>

        </Row>

        <span className="span-divider"></span>
        <h6 className="text-center text-muted">Período de Análise de Vendas</h6>

        <Row>
          <Col>
            <FormGroup>
              <Label>Início</Label>
              <ReactDatetime
                dateFormat
                closeOnSelect={true}
                name="nascimento"
                value={filtros.dataI}
                onChange={(e) => { onChangeDate(e, 'dataI') }}
                timeFormat={false}
                inputProps={{
                  className: "form-control",
                  placeholder: 'clique para selecionar'
                }}
              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="nascimento">Fim</Label>
              <ReactDatetime
                dateFormat
                closeOnSelect={true}
                name="nascimento"
                value={filtros.dataF}
                onChange={(e) => { onChangeDate(e, 'dataF') }}
                timeFormat={false}
                inputProps={{
                  className: "form-control",
                  placeholder: 'clique para selecionar'                  
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={analisar}>Analisar</Button>
            <Button className="bg-danger" onClick={() => { onClose() }}>Fechar</Button>
          </Col>
        </Row>

      </ModalFooter>
    </>


  )
}

export default Analisar